// extracted by mini-css-extract-plugin
module.exports = {"bullet-item-wrapper":"_80ad21f8ef--bullet-item-wrapper--2KcC3","container":"_80ad21f8ef--container--1iElp","col":"_80ad21f8ef--col--hhYmn"};